
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { ModuleItemProps } from ".";
import { loading, index, options } from "store/module";

interface ApiModuleInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiModuleOutputProps = OutputBaseProps<{ list: ModuleItemProps[]; pagination?: PaginationProps; }>

export const apiModuleIndex = async (data: ApiModuleInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiModuleOutputProps>("/api/modules", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiModuleOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiModuleOutputProps>("/api/modules", { params: { ...data } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};